import type {WasmWorkletNodeOptions} from '../worklets/types';

export const createDenoiseWorkletNode = (
    context: BaseAudioContext,
    options: WasmWorkletNodeOptions,
) => {
    return new AudioWorkletNode(context, 'denoise-processor', options);
};
